import React, { useState } from "react";
import Sidebar from "../../../components/Sidebar/Sidebar";
import { sendMailToAll } from "../../../utils/api";
import "./Mail.css";

const initialState = {
  subject: "",
  message: "",
  ctaText: "",
  ctaUrl: "",
};

export default function Mail() {
  const [formData, setFormData] = useState(initialState);
  const [sending, setSending] = useState(false);
  const [result, setResult] = useState(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.subject.trim()) {
      alert("Subject is required");
      return;
    }
    if (!formData.message.trim()) {
      alert("Message is required");
      return;
    }
    const hasCtaText = !!formData.ctaText.trim();
    const hasCtaUrl = !!formData.ctaUrl.trim();
    if (hasCtaText !== hasCtaUrl) {
      alert("Fill in both CTA text and CTA URL, or leave both empty");
      return;
    }

    if (
      !window.confirm(
        "This will send an email to ALL users. Are you sure you want to continue?"
      )
    ) {
      return;
    }

    try {
      setSending(true);
      setResult(null);
      const response = await sendMailToAll({
        subject: formData.subject.trim(),
        message: formData.message.trim(),
        ctaText: formData.ctaText.trim(),
        ctaUrl: formData.ctaUrl.trim(),
      });
      setResult(response);
      alert(response?.message || "Email sent");
    } catch (error) {
      alert(error.message || "Failed to send email");
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="dashboard-container">
      <Sidebar />
      <main className="dashboard-content">
        <div className="mail-wrapper">
          <header className="mail-header">
            <h2>Mail to all users</h2>
            <p>Send a broadcast email to every registered user.</p>
          </header>

          <form className="mail-card" onSubmit={handleSubmit}>
            <div className="form-section">
              <h3>Message</h3>
              <div className="form-group">
                <label>Subject *</label>
                <input
                  type="text"
                  name="subject"
                  value={formData.subject}
                  onChange={handleChange}
                  placeholder="Subject"
                  disabled={sending}
                  required
                />
              </div>
              <div className="form-group">
                <label>Message *</label>
                <textarea
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  rows="8"
                  placeholder="Message to all users"
                  disabled={sending}
                  required
                />
              </div>
            </div>

            <div className="form-section">
              <h3>Optional button in email</h3>
              <div className="form-row">
                <div className="form-group">
                  <label>CTA Text</label>
                  <input
                    type="text"
                    name="ctaText"
                    value={formData.ctaText}
                    onChange={handleChange}
                    placeholder="e.g. View now"
                    disabled={sending}
                  />
                </div>
                <div className="form-group">
                  <label>CTA URL</label>
                  <input
                    type="url"
                    name="ctaUrl"
                    value={formData.ctaUrl}
                    onChange={handleChange}
                    placeholder="https://example.com"
                    disabled={sending}
                  />
                </div>
              </div>
              <p className="mail-helper">
                Leave both fields empty if you don't want a button in the email.
              </p>
            </div>

            {result && (
              <div className="mail-result">
                <h4>Last send</h4>
                <div className="mail-result-grid">
                  <span>Recipients: {result.totalRecipients ?? 0}</span>
                  <span>Sent: {result.sentCount ?? 0}</span>
                  <span>Failed: {result.failedCount ?? 0}</span>
                </div>
              </div>
            )}

            <div className="form-actions">
              <button type="submit" className="btn btn-primary" disabled={sending}>
                {sending ? "Sending..." : "Send email"}
              </button>
            </div>
          </form>
        </div>
      </main>
    </div>
  );
}
